import { Link } from "react-router-dom";
import { Target, Shield, Zap, Users, Globe2, Award, ArrowRight, Heart } from "lucide-react";

const values = [
  { icon: Zap, title: "Önce performans", description: "Her kod satırı ve her ağ rotası ölçülür, kıyaslanır ve optimize edilir. Yavaş olmak bir hatadır." },
  { icon: Shield, title: "Güvenlik varsayılan", description: "Şifreleme, zero-trust ve denetim kayıtları premium özellik değil — her üründe standart." },
  { icon: Heart, title: "Mühendis destek", description: "Gerçek mühendisler yanıt verir. Senaryo yok, tier-1 engeli yok — sadece stack'i bilen insanlar." },
  { icon: Globe2, title: "İnternet için inşa", description: "Açık standartlar, taşınabilir iş yükleri, adil fiyat. Kilitlenmek yok, gizli ücret yok." },
];

const timeline = [
  { y: "2017", t: "DR SOFT, 3 mühendis ve 12 müşteri ile İstanbul'da kuruldu." },
  { y: "2019", t: "VPS ürün serisi lanse edildi, 10 bin aktif sunucu aşıldı." },
  { y: "2021", t: "Series B yatırımı alındı, Amsterdam ve Singapur'a genişlendi." },
  { y: "2023", t: "AI destekli WAF devreye alındı, 18 ay kesintisiz %99,99 uptime." },
  { y: "2025", t: "42 edge lokasyonunda 120.000+ ekip DR SOFT üzerinde çalışıyor." },
];

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 grid-overlay opacity-50 pointer-events-none" />
        <div className="absolute inset-x-0 top-0 h-96 radial-glow-blue pointer-events-none" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-8 pt-16 pb-24 lg:pt-24">
          <div className="max-w-4xl">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-blue-400 mb-5">DR SOFT Hakkında</p>
            <h1 className="font-heading text-5xl sm:text-6xl lg:text-7xl font-bold tracking-tight leading-[1.05]">
              Biz altyapıyı kuruyoruz,
              <br />
              <span className="text-zinc-500">siz geleceği inşa edin.</span>
            </h1>
            <p className="mt-8 text-lg text-zinc-400 max-w-2xl leading-relaxed">
              DR SOFT; hosting, compute ve güvenlik alanlarında faaliyet gösteren bir teknoloji
              şirketidir. Amacımız üretim seviyesi altyapıyı her ekibin erişebileceği hale getirmek.
            </p>
          </div>
        </div>
      </section>

      <section className="relative py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-2 gap-12 items-center">
          <div className="relative">
            <div className="absolute -inset-8 bg-blue-600/10 blur-3xl rounded-full pointer-events-none" />
            <div className="relative rounded-3xl overflow-hidden border border-white/10 shadow-2xl">
              <img src="https://images.pexels.com/photos/17489152/pexels-photo-17489152.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" alt="Sunucu altyapısı" className="w-full h-[500px] object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0B10] via-transparent to-transparent" />
            </div>
          </div>
          <div>
            <div className="inline-flex items-center gap-2 rounded-full border border-blue-500/20 bg-blue-500/5 px-3 py-1 mb-5">
              <Target size={14} className="text-blue-400" />
              <span className="text-xs font-semibold uppercase tracking-[0.18em] text-blue-400">Misyonumuz</span>
            </div>
            <h2 className="font-heading text-4xl sm:text-5xl font-semibold tracking-tight mb-6">
              Performans, güvenlik ve güvenilirlik — ek ücret olmadan.
            </h2>
            <p className="text-zinc-400 leading-relaxed mb-6">
              İnternetin daha iyi çalıştığına inanıyoruz — üst düzey altyapı uygun fiyatlı
              olduğunda. Bu yüzden tüm stack'imizi — özel router'lardan orkestrasyon katmanına
              kadar — kendimiz yönetiyoruz. Tasarrufu doğrudan müşterilerimize yansıtıyoruz.
            </p>
            <p className="text-zinc-400 leading-relaxed">
              Lock-in yok, sürpriz fatura yok, ikinci sınıf destek yok. Sadece kullanıcılarınızın
              beklediği hız, uptime ve güvenlik — size uyan bir fiyatla.
            </p>
          </div>
        </div>
      </section>

      <section className="relative py-24 bg-[#07080C]/40 border-y border-white/5">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="max-w-2xl mb-16">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-blue-400 mb-4">Değerlerimiz</p>
            <h2 className="font-heading text-4xl sm:text-5xl font-semibold tracking-tight">Her kararımıza rehberlik eden ilkeler.</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
            {values.map((v, i) => (
              <div key={v.title} data-testid={`value-card-${i}`} className="card-hover glass rounded-3xl p-8">
                <div className="w-12 h-12 rounded-xl bg-blue-500/10 border border-blue-500/20 flex items-center justify-center mb-6">
                  <v.icon size={22} strokeWidth={1.6} className="text-blue-400" />
                </div>
                <h3 className="font-heading text-lg font-semibold mb-3">{v.title}</h3>
                <p className="text-sm text-zinc-400 leading-relaxed">{v.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="relative py-24">
        <div className="max-w-5xl mx-auto px-6 lg:px-8">
          <div className="flex items-center gap-3 mb-12">
            <Award size={20} className="text-blue-400" />
            <h2 className="font-heading text-3xl sm:text-4xl font-semibold tracking-tight">Yolculuğumuz</h2>
          </div>
          <div className="relative pl-6 md:pl-10">
            <div className="absolute left-0 md:left-2 top-2 bottom-2 w-px bg-gradient-to-b from-blue-500/50 via-white/10 to-transparent" />
            <ul className="space-y-10">
              {timeline.map((item, i) => (
                <li key={item.y} data-testid={`timeline-${i}`} className="relative grid grid-cols-[auto_1fr] gap-6 items-start">
                  <div className="absolute -left-[21px] md:-left-[15px] top-2 w-3 h-3 rounded-full bg-blue-500 shadow-[0_0_20px_rgba(0,122,255,0.6)]" />
                  <span className="font-heading text-2xl font-bold text-blue-400 w-20">{item.y}</span>
                  <p className="text-zinc-300 leading-relaxed text-base md:text-lg pt-1">{item.t}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section className="relative py-20 bg-[#07080C]/40 border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
            {[
              { v: "120k+", l: "Aktif müşteri", i: Users },
              { v: "42", l: "Edge lokasyonu", i: Globe2 },
              { v: "180+", l: "Takım üyesi", i: Heart },
              { v: "8 yıl", l: "Kanıtlanmış uptime", i: Shield },
            ].map((s, i) => (
              <div key={s.l} data-testid={`about-stat-${i}`} className="glass rounded-2xl p-7 card-hover">
                <s.i size={18} className="text-blue-400 mb-4" strokeWidth={1.6} />
                <div className="font-heading text-3xl sm:text-4xl font-bold tracking-tight">{s.v}</div>
                <div className="mt-2 text-xs uppercase tracking-[0.18em] text-zinc-500">{s.l}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="relative py-24">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="font-heading text-4xl sm:text-5xl font-semibold tracking-tight mb-6">
            DR SOFT üzerinde inşa eden ekiplere katılın.
          </h2>
          <p className="text-zinc-400 mb-10 max-w-xl mx-auto">
            İster ilk sitenizi deploy edin, ister kritik bir iş yükünü taşıyın — yardımcı olmaktan
            mutluluk duyarız.
          </p>
          <div className="flex items-center justify-center gap-4 flex-wrap">
            <Link to="/fiyatlandirma" data-testid="about-cta-pricing" className="btn-shine inline-flex items-center gap-2 rounded-full bg-blue-600 hover:bg-blue-500 px-7 py-4 text-sm font-semibold text-white shadow-[0_0_30px_rgba(0,122,255,0.3)] transition-all">
              Paketleri gör <ArrowRight size={15} />
            </Link>
            <Link to="/iletisim" data-testid="about-cta-contact" className="inline-flex items-center gap-2 rounded-full border border-white/15 hover:border-white/30 bg-white/5 hover:bg-white/10 px-7 py-4 text-sm font-semibold text-white transition-all">
              Bize yazın
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
